import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import topics from "@/data/topics.json";
import { Reveal, Eyebrow, MaskLines } from "./Reveal";

export const TopicList = () => (
  <section id="topics" data-testid="topic-list-section" className="px-5 sm:px-10 lg:px-16 py-24 sm:py-32 border-t border-white/10">
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
      <div>
        <Eyebrow className="mb-5">// {topics.length} topics</Eyebrow>
        <h2 className="font-display font-bold uppercase text-4xl sm:text-6xl lg:text-7xl leading-[0.9]">
          <MaskLines lines={["Explore", <span className="text-lime">the topics</span>]} />
        </h2>
      </div>
      <Link data-testid="all-topics-link" to="/topics" className="group inline-flex items-center gap-3 self-start md:self-auto rounded-full bg-lime text-ink font-mono text-[12px] uppercase tracking-[0.2em] px-6 py-3 hover:bg-white transition-colors duration-300">
        All topics <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:rotate-45" />
      </Link>
    </div>
    <Reveal>
      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-white/10">
        {topics.map((t, i) => (
          <li key={t.slug} className="border-b border-r border-white/10">
            <Link
              data-testid={`topic-link-${t.slug}`}
              to={`/${t.slug}`}
              className="group relative flex items-center justify-between gap-4 px-5 py-5 overflow-hidden"
            >
              <span className="absolute inset-0 bg-lime origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500 ease-out" />
              <span className="relative flex items-baseline gap-4 group-hover:text-ink transition-colors duration-300">
                <span className="font-mono text-[12px] text-zinc-400 group-hover:text-ink/70">{String(i + 1).padStart(2, "0")}</span>
                <span className="font-display font-semibold text-lg sm:text-xl">{t.title}</span>
              </span>
              <ArrowUpRight className="relative w-5 h-5 shrink-0 text-lime group-hover:text-ink group-hover:rotate-45 transition-transform duration-300" />
            </Link>
          </li>
        ))}
      </ul>
    </Reveal>
  </section>
);
